import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import "./suggestionBox.css";
import { useProductsData } from "../../context/product-context";

export const SuggestionBox = () => {
  const { productData, setShowBox } = useProductsData();
  const [onProductPage, setOnProductPage] = useState(false);
  const outsideClick = useRef(null);

  const navigate = useNavigate();
  const cardHandler = () => {
    navigate("/products");
    setOnProductPage(true);
    setShowBox(false);
  };

  function useOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowBox(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideClick(outsideClick);

  return (
    <div className="wrapper" ref={outsideClick}>
      <div
        className={`suggestion-con ${
          onProductPage ? "suggestion-con-prod" : ""
        }`}
      >
        <h4>Latest Trends</h4>
        <div className="sugg-prod-con">
          {productData.slice(0, 5).map((prod) => (
            <div key={prod.id} className="prod" onClick={() => cardHandler()}>
              <div>
                <img
                  src={prod.thumbnail}
                  alt={prod.title}
                  className="prod-img-cat"
                />
              </div>
              <p className="prod-title grey-text">{prod.title}</p>
            </div>
          ))}
        </div>
        <div className="sugg-btm">
          <h4>Popular Suggestions</h4>
          {productData.slice(5, 10).map((prod) => (
            <p className="prod-title grey-text" key={prod.id}>
              {prod.title}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};
